export const BILLING_ENTITY_TYPE_INDIVIDUAL = "INDIVIDUAL";
export const BILLING_ENTITY_TYPE_COMPANY = "COMPANY";
